// Firebase
import { db, auth, storage } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, serverTimestamp, orderBy, increment, startAfter, limit, onSnapshot } from 'firebase/firestore';

import {
    GET_CATEGORY,
    GET_CATEGORIES,
    SET_CATEGORIES,
    SET_LAST_CATEGORIES,
    CATEGORY_ERROR,
    CLEAR_CATEGORIES,
    CLEAR_CATEGORY,
    CATEGORIES_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES,
    SET_LAST_CATEGORY_DOC,
    SET_NO_MORE_CATEGORIES
} from './types';
import { setAlert } from './alertActions';

// Reference to collections in Firestore
const categoriesCollectionRef = collection(db, "categories");

// Get group by id
export const getCategoryByUrlHandle = url_handle => async dispatch => {

    // Dispatch the clearCategory action to reset the user state
    dispatch(clearCategory());
    try {

        // Create a query to retrieve posts 
        let q = query(categoriesCollectionRef, where("url_handle", "==", url_handle));

        // Fetch posts
        const snapshot = await getDocs(q);
        
        console.log('GOT CATEGORY BY URL HANDLE');

        if(snapshot.docs[0].data()) {

            const categoryData = {
                ...snapshot.docs[0].data(), 
                _id: snapshot.docs[0].id
            };

            // Dispatch an action of type GET_CATEGORY with the post data and ID as the payload
            dispatch({
                type: GET_CATEGORY,
                payload: categoryData
            });
        } else {
            dispatch({
                type: GET_CATEGORY,
                payload: null
            });

            dispatch(setAlert("Sorry, this category doesn't exist.", 'okay'));
        }
    } catch (err) {

        // If an error occurs, dispatch the CATEGORY_ERROR action with an error message and status code as the payload
        dispatch({
            type: CATEGORY_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        console.log(err);
    }
}

// Fill the categories array with everything in the given array
export const setCategory = category_obj => dispatch => {
    console.log('SETTING CATEGORY NOW');

    dispatch({
        type: GET_CATEGORY,
        payload: category_obj
    });
};

// Fill the categories array with everything in the given array
export const setCategories = arrayOfCategories => dispatch => {
    console.log('SETTING CATEGORIES NOW');

    dispatch({
        type: SET_CATEGORIES,
        payload: arrayOfCategories
    });
};

// Remove current category info from state
export const clearCategory = () => dispatch => {
    dispatch({
        type: CLEAR_CATEGORY
    });

}

// --- Infinite Scroll Functions ---

export const set_ShowBottomSpinner = (value) => dispatch => {

    dispatch({
        type: SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES,
        payload: value
    });

}

export const set_LastPageDoc = (doc) => dispatch => {

    dispatch({
        type: SET_LAST_CATEGORY_DOC,
        payload: doc
    });

}

export const set_NoMoreUsers = (value) => dispatch => {

    dispatch({
        type: SET_NO_MORE_CATEGORIES,
        payload: value
    });

}

// --- END: Infinite Scroll Functions ---